import { ReactNode } from "react";
import { MarketingThemeProvider } from "@/components/marketing/v2/MarketingThemeProvider";
import { MarketingNav } from "@/components/marketing/v2/MarketingNav";
import { MarketingFooter } from "@/components/marketing/v2/MarketingFooter";

interface SEOLayoutProps {
  children: ReactNode;
  canonicalUrl?: string;
}

export const SEOLayout = ({ children }: SEOLayoutProps) => {
  return (
    <MarketingThemeProvider>
      <div className="flex flex-col min-h-screen">
        <MarketingNav />
        <main className="flex-1">{children}</main>
        <MarketingFooter />
      </div>
    </MarketingThemeProvider>
  );
};
